if (!customElements.get('ht-quick-buy')) {
  customElements.define('ht-quick-buy', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.nativeButton = this.productInfo?.querySelector('.product-form__submit');
      if (!this.nativeButton) return;
      this.button = this.querySelector('[data-quick-submit]');
      this.choice = this.querySelector('[data-quick-choice]');
      this.intersection = new IntersectionObserver(entries => { this.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
      this.intersection.observe(this.nativeButton);
      this.mutation = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      });
      this.mutation.observe(this.productInfo, { subtree: true, childList: true, attributes: true });
      this.sync();
    }
    sync() {
      this.nativeButton = this.productInfo.querySelector('.product-form__submit');
      if (!this.nativeButton) return;
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || this.nativeButton.textContent.trim();
      try {
        const variant = JSON.parse(this.productInfo.querySelector('[data-selected-variant]')?.textContent || 'null');
        if (variant) {
          const price = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100);
          this.choice.textContent = `${variant.title} · ${price}`;
        }
      } catch {}
    }
    disconnectedCallback() {
      this.intersection?.disconnect();
      this.mutation?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
